import { render, staticRenderFns } from "./MainColumnDelete.vue?vue&type=template&id=432e5586&scoped=true&"
import script from "./MainColumnDelete.vue?vue&type=script&lang=js&"
export * from "./MainColumnDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432e5586",
  null
  
)

export default component.exports